module.exports = __webpack_public_path__ + "static/media/img_monumento.90a3a2de.jpg";